import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResourceUUIDVersionIdentifier } from 'src/app/common/model/resource-id-version-identifier';
import { RestService } from 'src/app/shared/service/rest.service';
import { LineDirectionCountersResetsDto } from './line-direction-counters-reset.dto';

@Injectable()
export class LineDirectionCountersResetsService extends RestService {


    save(dto: any): Observable<ResourceUUIDVersionIdentifier> {
        return this.doPost<string>('api/line-direction-passengers-resets', dto)
            .pipe(map(v => ResourceUUIDVersionIdentifier.createFromString(v)));
    }

    update(id: ResourceUUIDVersionIdentifier, dto: any): Observable<ResourceUUIDVersionIdentifier> {
        return this.doPatch<string>('api/line-direction-passengers-resets/' + id, dto)
            .pipe(map(v => ResourceUUIDVersionIdentifier.createFromString(v)));
    }

    getById(id: string): Observable<LineDirectionCountersResetsDto> {
        return this.doGet<LineDirectionCountersResetsDto>(`api/line-direction-passengers-resets/${id}`)
            .pipe(map(v => plainToClass(LineDirectionCountersResetsDto, v)));
    }

    getByCarrier(carrierId: number): Observable<LineDirectionCountersResetsDto[]> {
        return this.doGet<LineDirectionCountersResetsDto[]>(`api/line-direction-passengers-resets/carrier/${carrierId}`)
            .pipe(map(v => plainToClass(LineDirectionCountersResetsDto, v)));
    }

    delete(id: ResourceUUIDVersionIdentifier): Observable<any> {
        return this.doDelete(`api/line-direction-passengers-resets/${id}`);
    }

    getByCarrierLineDir(carrierId: number, lineNumber: string, dirName: string): Observable<LineDirectionCountersResetsDto> {
        return this.doGet<LineDirectionCountersResetsDto>(`api/line-direction-passengers-resets/carrier/${carrierId}/line/${lineNumber}/direcion/${dirName}`)
            .pipe(map(v => plainToClass(LineDirectionCountersResetsDto, v)));
    }

}
